import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // { id, title, price, weight, quantity }
  totalQuantity: 0,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { id, weight } = action.payload;
      const existingItem = state.items.find(
        (item) => item.id === id && item.weight === weight
      );
      if (existingItem) {
        existingItem.quantity += action.payload.quantity;
      } else {
        state.items.push(action.payload);
      }
      // تعداد آیتم‌های یکتا
      state.totalQuantity = state.items.length;
    },
    removeFromCart: (state, action) => {
      const { id, weight } = action.payload;
      state.items = state.items.filter(
        (item) => !(item.id === id && item.weight === weight)
      );
      state.totalQuantity = state.items.length
    },
    
    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
    },
  },
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
